import Vue from 'vue';
import VueRouter from 'vue-router';
import Shipinjianjizhong from '../pages/shipinjianjizhong/shipinjianjizhong.vue';
import Weiguitishi from '../pages/weiguitishi/weiguitishi.vue';
import Shipinpaishe from '../pages/shipinpaishe/shipinpaishe.vue';
import Xiugaijiaoben from '../pages/xiugaijiaoben/xiugaijiaoben.vue';
import Shipinjianjizhong_1 from '../pages/shipinjianjizhong_1/shipinjianjizhong_1.vue';
import Jianjiwancheng from '../pages/jianjiwancheng/jianjiwancheng.vue';
import Xiangqingye from '../pages/xiangqingye/xiangqingye.vue';
import Wode from '../pages/wode/wode.vue';
import Xiangce from '../pages/xiangce/xiangce.vue';
import Shouye from '../pages/shouye/shouye.vue';
import Zhuanti from '../pages/zhuanti/zhuanti.vue';
import Tishiye from '../pages/tishiye/tishiye.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/shipinjianjizhong',
    name: 'shipinjianjizhong',
    component: Shipinjianjizhong,
  },
  {
    path: '/weiguitishi',
    name: 'weiguitishi',
    component: Weiguitishi,
  },
  {
    path: '/shipinpaishe',
    name: 'shipinpaishe',
    component: Shipinpaishe,
  },
  {
    path: '/xiugaijiaoben',
    name: 'xiugaijiaoben',
    component: Xiugaijiaoben,
  },
  {
    path: '/shipinjianjizhong_1',
    name: 'shipinjianjizhong_1',
    component: Shipinjianjizhong_1,
  },
  {
    path: '/jianjiwancheng',
    name: 'jianjiwancheng',
    component: Jianjiwancheng,
  },
  {
    path: '/xiangqingye',
    name: 'xiangqingye',
    component: Xiangqingye,
  },
  {
    path: '/wode',
    name: 'wode',
    component: Wode,
  },
  {
    path: '/xiangce',
    name: 'xiangce',
    component: Xiangce,
  },
  {
    path: '/shouye',
    name: 'shouye',
    component: Shouye,
  },
  {
    path: '/zhuanti',
    name: 'zhuanti',
    component: Zhuanti,
  },
  {
    path: '/',
    name: 'tishiye',
    component: Tishiye,
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

export default router;
